import {
  decimalOfInteger,
  isDecimalInteger,
  roundDecimalInteger,
  roundUpDecimalInteger
} from 'powtoon-commons/utils/numbers'
import {
  formatFractionalQuarterSeconds,
  formatDurationOutput
} from 'powtoon-commons/utils/datetime'

export const roundTrackTime = roundDecimalInteger
export const roundUpTrackTime = roundUpDecimalInteger

export const isTrackTimeValid =  isDecimalInteger

export const getMinTimeStep = () => decimalOfInteger

export const formatFractionalSeconds = formatFractionalQuarterSeconds

export const formatDecimalDurationOutput = (total) => formatDurationOutput(total, formatFractionalSeconds)
